import styles from './FooterCopyright.module.css';
import YandexProjectLogo from './YandexProjectLogo';

export default function FooterCopyright() {
    return <div className={styles.container}>
        <div className={styles.copyright}>
            <div className="Footer_copyright_left">
                © 2017—2024
            </div>
            <div className="Footer_copyright_right">
                Яндекс Драйв
            </div>
        </div>
        <div className={styles.yandex_project_logo}>
            <YandexProjectLogo />
        </div>
    </div>
}
